import React from 'react';
import { RouteComponentProps, RouteProps } from 'react-router-dom';
import Breadcrumbs, { BreadcrumbData } from '../Breadcrumbs/Breadcrumbs';
import RoleBasedRoute, { Props as RoleBasedProps } from 'components/RoleBasedRoute/RoleBasedRoute';

interface P extends RouteProps {
  includeSearch?: boolean;
  title: string | string[]; // translatable key
  home?: string;
}

const renderComponent = (
  Component: React.ComponentType<RouteComponentProps<any>> | React.ComponentType<any> | undefined,
  render: ((props: RouteComponentProps<any>) => React.ReactNode) | undefined,
  routeProps: RouteComponentProps,
) => {
  if (Component) {
    return <Component {...routeProps} />;
  }
  if (render) {
    return render(routeProps);
  }
  return <div>Nothing to render for this route!</div>;
};

const Render = ({ includeSearch = false, title, home, ...props }: P & RoleBasedProps) => {
  const titles = !Array.isArray(title) ? [title] : title;
  const { component, render, ...routeProps } = props;

  return (
    <RoleBasedRoute
      {
        ...routeProps
      }
      render={(routeProps: any) => (
        <Breadcrumbs
          home={home}
          fullPath={routeProps.match.url}
          data={titles.map(
            (title): BreadcrumbData => ({
              title,
              search: includeSearch ? routeProps.location.search : undefined,
            }),
          )}
        >
          {renderComponent(component, render, routeProps)}
        </Breadcrumbs>
      )}
    />
  );
};

export default Render;
